import { Route } from "react-router-dom";
import OverviewDashboard from "../../screens/admin/OverviewDashboard";
import AdminDashboard from "../../screens/admin/AdminDashboard";
import DetailedFarmerView from "../../screens/admin/DetailedFarmerView";
import ResetPasswordUsers from "../../screens/admin/ResetPasswordUsers";
import Campaigns from "../../screens/admin/Campaigns";
import CampaignDetails from "../../screens/admin/CampaignDetails";
import BiocharDetails from "../../screens/admin/BiocharDetails";
import DetailedBiocharView from "../../screens/admin/DetailedBiocharView";
import FarmsOverview from "../../screens/admin/FarmsMapSummary";
import BiocharProcurements from "../../screens/admin/BiocharProcurements";
import ProcurementDetail from "../../screens/biochar/ProcurementDetail";
import Biochar from "../../screens/admin/Biochar";
import BiocharForms from "../../screens/admin/BiocharForms";
import BiocharSaleOrders from "../../screens/admin/BiocharSaleOrders";
import PaymentDetails from "../../screens/admin/PaymentDetails";
import SubscriptionInvoice from "../../screens/admin/SubscriptionInvoice";
import DetailInvoiceView from "../../screens/admin/DetailInvoiceView";

export const centralAdminRoutes = [
  <Route key="central-admin-home" path="/" element={<OverviewDashboard />} />,
  <Route
    key="central-admin-farmers"
    path="/admin/farmers"
    element={<AdminDashboard />}
  />,
  <Route
    key="central-admin-farmer-details"
    path="/farmer-details/:farmerId"
    element={<DetailedFarmerView />}
  />,
  <Route
    key="central-admin-campaigns"
    path="/admin/campaigns"
    element={<Campaigns />}
  />,
  <Route
    key="central-admin-campaign-details"
    path="/campaign-details/:campaignId"
    element={<CampaignDetails />}
  />,
  <Route
    key="central-admin-reset-password"
    path="/reset-password-users"
    element={<ResetPasswordUsers />}
  />,
  <Route
    key="central-admin-farms-overview"
    path="/admin/farms-overview"
    element={<FarmsOverview />}
  />,
  <Route
    key="central-admin-biochar-details-id"
    path="/biochar-details/:biocharId"
    element={<DetailedBiocharView />}
  />,
  <Route
    key="central-admin-biochar-details"
    path={"/biochar-details"}
    element={<BiocharDetails />}
  />,
  <Route
    key="central-admin-biochar-procurements"
    path={"/biochar-procurements"}
    element={<BiocharProcurements />}
  />,
  <Route
    key="central-admin-procurement"
    path="/procurement/:id"
    element={<ProcurementDetail />}
  />,
  <Route
    key="central-admin-biochar"
    path={"/admin/biochar"}
    element={<Biochar />}
  />,
  <Route
    key="central-admin-biochar-forms"
    path="/biochar-forms"
    element={<BiocharForms />}
  />,
  <Route
    key="central-admin-biochar-orders"
    path="/biochar-orders"
    element={<BiocharSaleOrders />}
  />,
  <Route
    key="central-admin-payment-details"
    path="/payments"
    element={<PaymentDetails />}
  />,
  <Route
    key="central-admin-subscription-invoice"
    path="/subscription-invoice"
    element={<SubscriptionInvoice />}
  />,
  <Route
    key="central-admin-subscription-invoice-detail-view"
    path="/subscription-invoice-detail/:invoiceUUID"
    element={<DetailInvoiceView />}
  />,
];
